var styles = {
raw: ".hcr-link-2-2-3{background-color:transparent;color:#00b5e2;color:var(--hcr-link-color);font-weight:400;font-weight:var(--hcr-font-weight-semibold);text-decoration:none}.hcr-link-2-2-3:active,.hcr-link-2-2-3:focus,.hcr-link-2-2-3:hover{color:#00b5e2;color:var(--hcr-link-color);text-decoration:underline}",
map:{"hcr-link":"hcr-link-2-2-3"}};

export default styles;
